import { TextField } from '@purpur/library';
import styled, { css } from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const InputRangesContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 1rem;
`;

const thumbStyles = css`
    appearance: none;
    pointer-events: all;
    width: 1rem;
    height: 1rem;
    background-color: ${getPurpurColor('backgroundInteractivePrimary')};
    border-radius: ${getPurpurBorder('radiusFull')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderInteractivePrimary')};
    cursor: pointer;
    ${purpurFocus()};
`;

const thumbFocusStyles = css`
    outline: solid ${getPurpurBorder('widthSm')} ${getPurpurColor('borderInteractiveFocus')};
    outline-offset: ${getPurpurSpacing('25')};
    box-shadow: none;
`;

const InputRange = styled.input.attrs({ type: 'range' })`
    appearance: none;
    height: 0.125rem;
    width: 100%;
    position: absolute;
    background-color: ${getPurpurColor('gray400')};
    pointer-events: none;

    &::-webkit-slider-thumb {
        ${thumbStyles};
    }
    &::-moz-range-thumb {
        ${thumbStyles};
    }

    &:focus {
        outline: 0;
        &::-webkit-slider-thumb {
            ${thumbFocusStyles};
        }
        &::-moz-range-thumb {
            ${thumbFocusStyles};
        }
    }
    &:focus:not(:focus-visible) {
        &::-webkit-slider-thumb {
            outline: 0;
        }
        &::-moz-range-thumb {
            outline: 0;
        }
    }
`;

export const FromInputRange = styled(InputRange)`
    height: 0;
    z-index: 1;
`;

export const ToInputRange = styled(InputRange)``;

export const TextFieldsContainer = styled.div`
    width: 100%;
    display: flex;
    gap: ${getPurpurSpacing('200')};
    margin-bottom: ${getPurpurSpacing('600')};
`;

export const RangeTextField = styled(TextField)`
    flex: 1;
`;
